import type { ReactNode } from 'react';
import { useAuth } from '@/app/AuthContext';
import { Icon } from './Icon';
import { v } from '@/theme/tokens';

/** Renders children only when the user holds every listed permission. */
export function PermissionGate({
  permission,
  children,
  fallback = null,
}: {
  permission: string | string[];
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const { can } = useAuth();
  const codes = Array.isArray(permission) ? permission : [permission];
  return codes.every((code) => can(code)) ? <>{children}</> : <>{fallback}</>;
}

/**
 * Shown when someone reaches a page they may not see — typing the URL by hand,
 * for instance. The server refuses the same request independently.
 */
export function Forbidden({ message }: { message?: string }) {
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: '80px 24px',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: 52,
          height: 52,
          borderRadius: 14,
          background: v('warning-soft'),
          color: v('warning'),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon name="lock" size={24} />
      </div>
      <div style={{ fontSize: 17, fontWeight: 700 }}>Недостаточно прав</div>
      <div style={{ fontSize: 13.5, color: v('ink-muted'), maxWidth: 380 }}>
        {message ?? 'Системные настройки доступны только владельцу.'}
      </div>
    </div>
  );
}
